/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bell_Activity_Lines_OneInputs */

const en_bell_activity_lines_one = /** @type {(inputs: Bell_Activity_Lines_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 line changed`)
};

/**
* | output |
* | --- |
* | "1 line changed" |
*
* @param {Bell_Activity_Lines_OneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_activity_lines_one = /** @type {((inputs?: Bell_Activity_Lines_OneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Activity_Lines_OneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_activity_lines_one(inputs)
});